<template>
  <b-container>
    <b-row class="my-1">
      <b-col sm="3">
        <label :for="plz">PLZ</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="plz" type="text"></b-form-input>
      </b-col>
      <b-col sm="3">
        <label :for="feldname">Name</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="feldname" type="text"></b-form-input>
      </b-col>
      <b-col sm="3">
        <label :for="address">Addresse</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="address" type="text"></b-form-input>
      </b-col>
      <b-col sm="3">
        <label :for="description">Beschreibung</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="description" type="text"></b-form-input>
      </b-col>
      <b-col sm="3">
        <label :for="pricePerHour">Preis pro Stunde</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="pricePerHour" type="text"></b-form-input>
      </b-col>
      <b-col sm="3">
        <label :for="sportId">sportId</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="sportId" type="text"></b-form-input>
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "CreateField",
  data() {
    return {
      plz : null
    }
  }
}
</script>

<style scoped>

</style>